// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__849ew","spin":"loader_spin__KkRG5"};